import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import axios from "axios";
import { action, computed, observable, runInAction, makeObservable } from "mobx";
import Base from "./Base";
import { cacheResponse, wrapCacheAdapter, lookupCache } from "../utils/cache";
import { toInteger } from "@dp/common";
import DPServices from "@dp/services";
var BYPASS_NETWORK_BUSY_API_PREFIXES = [DPServices.Config.postfix.RECOMMENDATION_LIST_API, DPServices.Config.postfix.MENU_ITEMS_86ED, DPServices.Config.postfix.MAPBOX_DISTANCE, DPServices.Config.postfix.MAPBOX_SEARCH_AUTOCOMPLETE, DPServices.Config.postfix.MENU_DAY_PART_API, DPServices.Config.postfix.ITEM_86ED];
var MAX_REQUEST_RETRIES = 3;
var RETRY_REQUEST_METHODS = ["GET"];
var DEFAULT_API_TIMEOUT = 10000;
var TIMEOUT_INCREMENT_STEP = 2000;
var Network = (_class = /*#__PURE__*/function (_Base) {
  _inherits(Network, _Base);

  var _super = _createSuper(Network);

  function Network(rootStore) {
    var _this;

    _classCallCheck(this, Network);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "_pendingRequests", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "networkFailed", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "isCancelled", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isBusy", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_enableNetworkRetryOnError", _descriptor5, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "timeout", DEFAULT_API_TIMEOUT);

    _defineProperty(_assertThisInitialized(_this), "failedRequestQueue", []);

    _defineProperty(_assertThisInitialized(_this), "requestQueue", []);

    _this.rootStore = rootStore;
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Network, [{
    key: "setupReactions",
    value: function setupReactions() {
      return;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setInterval(function () {
                  runInAction(function () {
                    _this2._isBusy = _this2.isNetworkBusy();
                  });
                }, 200);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "setTimeout",
    value: function setTimeout(timeout) {
      this.timeout = timeout;
    }
  }, {
    key: "isNetworkBusy",
    value: function isNetworkBusy() {
      var ret;

      if (this.networkFailed) {
        ret = false;
      } else {
        if (this._pendingRequests > 0) {
          ret = true;
        } else {
          ret = false;
        }
      }

      return ret;
    }
  }, {
    key: "getFailedRequestsAPIIds",
    value: function getFailedRequestsAPIIds() {
      var failedRequests = this.failedRequestQueue;
      return failedRequests.reduce(function (coll, failedRequest) {
        var config = failedRequest.config;
        var headers = config.headers;

        if (headers) {
          var apiId = headers["X-API-ID"];

          if (apiId) {
            coll.push("API:" + apiId);
          }
        }

        return coll;
      }, []);
    }
  }, {
    key: "beginRequest",
    value: function () {
      var _beginRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(config) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(function (resolve, reject) {
                  lookupCache(config, _this3.rootStore.platformUtil).then(function (cacheEntry) {
                    if (cacheEntry) {
                      wrapCacheAdapter(cacheEntry, config).then(function (wrappedConfig) {
                        resolve(wrappedConfig);
                      });
                    } else {
                      if (_this3.networkFailed) {
                        runInAction(function () {
                          if (!_this3.requestQueue) {
                            _this3.requestQueue = [];
                          }

                          _this3.requestQueue.push({
                            config: config,
                            resolve: resolve,
                            reject: reject
                          });
                        });
                      } else {
                        runInAction(function () {
                          if (_this3.canTrackRequest(config)) {
                            _this3._pendingRequests++;
                          }
                        });

                        if (_this3.isRequestEligibleForRetryOnTimeout(config)) {
                          config.timeout = _this3.getRequestTimeout(config);
                        } else {
                          if (config.timeout) {
                            config.timeout = null;
                          }
                        }

                        resolve(config);
                      }
                    }
                  });
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function beginRequest(_x) {
        return _beginRequest.apply(this, arguments);
      }

      return beginRequest;
    }()
  }, {
    key: "canTrackRequest",
    value: function canTrackRequest(config) {
      var headers = config.headers;
      var apiId = headers ? headers["X-API-ID"] : null;

      if (apiId) {
        var canTrack = true;
        BYPASS_NETWORK_BUSY_API_PREFIXES.forEach(function (prefix) {
          var urlHash = DPServices.Core.hashCode(prefix);

          if (apiId === urlHash) {
            canTrack = false;
          }
        });
        return canTrack;
      } else {
        return true;
      }
    }
  }, {
    key: "endRequest",
    value: function endRequest(response) {
      var _this4 = this;

      return new Promise(function (resolve) {
        if (response) {
          cacheResponse(response, _this4.rootStore.platformUtil).then(function () {
            if (_this4._pendingRequests > 0) {
              runInAction(function () {
                var config = response.config;

                if (_this4.canTrackRequest(config)) {
                  _this4._pendingRequests--;
                }
              });
            }

            resolve();
          });
        } else {
          resolve();
        }
      });
    }
  }, {
    key: "errorRequest",
    value: function errorRequest(error) {
      var _this5 = this;

      if (this._pendingRequests > 0) {
        runInAction(function () {
          var config = error.config;

          if (_this5.canTrackRequest(config)) {
            _this5._pendingRequests--;
          }
        });
      }

      if (this._enableNetworkRetryOnError) {
        return new Promise(function (resolve, reject) {
          var code = error.code;
          var config = error.config;
          var response = error.response;
          var status = response ? response.status : null;

          if (status === 401
          /* || status === 403*/
          ) {
            reject(error);

            _this5.cancel();
          } else {
            _this5.handleErrorRequest(code, status, config, error, reject, resolve);
          }
        });
      } else {
        return Promise.reject(error);
      }
    }
  }, {
    key: "handleErrorRequest",
    value: function handleErrorRequest(code, status, config, error, reject, resolve) {
      var _this6 = this;

      if (code === "ECONNABORTED" || !status) {
        console.log("====================== Start: Handle Error Request");
        console.log(config.url);
        console.log("----");
        console.log(code);
        console.log("----");
        console.log(status);
        console.log("----");
        console.log(error);

        if (config) {
          var canRetry = this.canRetryRequest(config, error);

          if (canRetry) {
            console.log("============= Request can be re-tried");
            this.retryFailedRequest(config, resolve, reject);
          } else {
            console.log("============= Request cannot be re-tried");
            runInAction(function () {
              _this6.networkFailed = true;

              if (!_this6.failedRequestQueue) {
                _this6.failedRequestQueue = [];
              }

              _this6.failedRequestQueue.push({
                config: config,
                error: error,
                reject: reject,
                resolve: resolve
              });
            });
          }
        } else {
          runInAction(function () {
            _this6.networkFailed = true;
          });
          reject(error);
        }

        console.log("====================== End: Handle Error Request");
      } else {
        reject(error);
      }
    }
  }, {
    key: "isRequestEligibleForRetryOnTimeout",
    value: function isRequestEligibleForRetryOnTimeout(config) {
      var type = config.method;
      var headers = config.headers;
      var retryOnTimeout = headers === null || headers === void 0 ? void 0 : headers["x-retry-on-timeout"];
      console.log("============> Type", type);
      console.log("============> URL", config.url);
      return this._enableNetworkRetryOnError && type && (retryOnTimeout || RETRY_REQUEST_METHODS.indexOf(type.toUpperCase()) >= 0);
    }
  }, {
    key: "canRetryRequest",
    value: function canRetryRequest(config, error) {
      var headers = config.headers;
      var retryCount = toInteger(headers === null || headers === void 0 ? void 0 : headers["x-retry-count"], 1);
      var errorMessage = error ? error.message : null;
      var isTimedOutRequest = errorMessage && errorMessage.indexOf("timeout") >= 0;
      var eligibleForRetryOnTimeout = this.isRequestEligibleForRetryOnTimeout(config);
      console.log("============> retryCount", retryCount);
      console.log("============> isTimedOutRequest", isTimedOutRequest);
      console.log("============> eligibleForRetryOnTimeout", eligibleForRetryOnTimeout);
      console.log("============> URL", config.url);
      return eligibleForRetryOnTimeout && retryCount < MAX_REQUEST_RETRIES && isTimedOutRequest;
    }
  }, {
    key: "flush",
    value: function flush() {
      this.networkFailed = false;
      this.isCancelled = false;

      if (this.failedRequestQueue) {
        while (this.failedRequestQueue.length > 0) {
          var _this$failedRequestQu = this.failedRequestQueue.pop(),
              _config = _this$failedRequestQu.config,
              resolve = _this$failedRequestQu.resolve,
              reject = _this$failedRequestQu.reject;

          var headers = _config.headers;

          if (headers && headers.length) {
            delete headers["x-retry-count"];
          }

          this.retryFailedRequest(_config, resolve, reject);
        }
      }

      if (this.requestQueue) {
        while (this.requestQueue.length > 0) {
          var _this$requestQueue$po = this.requestQueue.pop(),
              _config2 = _this$requestQueue$po.config,
              _resolve = _this$requestQueue$po.resolve;

          _resolve(_config2);
        }
      }
    }
  }, {
    key: "tagRequest",
    value: function tagRequest(config) {
      if (config && !config.headers["x-request-id"]) {
        var ts = Date.now();
        config.headers["x-request-id"] = "REQ_" + ts;
      }

      return config;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.isCancelled = true;

      if (this.failedRequestQueue) {
        while (this.failedRequestQueue.length > 0) {
          var _this$failedRequestQu2 = this.failedRequestQueue.pop(),
              error = _this$failedRequestQu2.error,
              reject = _this$failedRequestQu2.reject;

          reject(error);
        }
      }

      if (this.requestQueue) {
        while (this.requestQueue.length > 0) {
          var _this$requestQueue$po2 = this.requestQueue.pop(),
              _reject = _this$requestQueue$po2.reject;

          _reject(new Error("Network failure"));
        }
      }
    }
  }, {
    key: "retryFailedRequest",
    value: function retryFailedRequest(config, resolve, reject) {
      var _config$headers;

      delete config.transformRequest;
      var currCount = toInteger((_config$headers = config.headers) === null || _config$headers === void 0 ? void 0 : _config$headers["x-retry-count"], 1);

      if (config.headers) {
        config.headers["x-retry-count"] = currCount + 1;
      } else {
        config.headers = {
          "x-retry-count": currCount + 1
        };
      }

      axios.request(config).then(function (response) {
        resolve(response);
      }, function (err) {
        reject(err);
      });
    }
  }, {
    key: "getRequestTimeout",
    value: function getRequestTimeout(config) {
      var _config$headers2;

      var currCount = toInteger((_config$headers2 = config.headers) === null || _config$headers2 === void 0 ? void 0 : _config$headers2["x-retry-count"], 1);
      return this.timeout + (currCount - 1) * TIMEOUT_INCREMENT_STEP;
    }
  }, {
    key: "pendingRequests",
    get: function get() {
      return this._pendingRequests;
    }
  }, {
    key: "enableNetworkRetryOnError",
    set: function set(val) {
      var _this7 = this;

      runInAction(function () {
        _this7._enableNetworkRetryOnError = val;
      });
    },
    get: function get() {
      return this._enableNetworkRetryOnError;
    }
  }, {
    key: "isBusy",
    get: function get() {
      return this._isBusy;
    }
  }]);

  return Network;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_pendingRequests", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "networkFailed", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isCancelled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_isBusy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_enableNetworkRetryOnError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "enableNetworkRetryOnError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "enableNetworkRetryOnError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isBusy", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isBusy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "beginRequest", [action], Object.getOwnPropertyDescriptor(_class.prototype, "beginRequest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "endRequest", [action], Object.getOwnPropertyDescriptor(_class.prototype, "endRequest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorRequest", [action], Object.getOwnPropertyDescriptor(_class.prototype, "errorRequest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleErrorRequest", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleErrorRequest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "flush", [action], Object.getOwnPropertyDescriptor(_class.prototype, "flush"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cancel"), _class.prototype)), _class);
export { Network as default };